import { h, Host } from "@stencil/core";
/**
 * The `ux-copy` component is used to display text.
 * @slot - The default slot where text content is placed.
 * @internal Currently only for usage in web-apps.
 */
export class Copy {
    constructor() {
        this.strong = undefined;
        this.light = undefined;
        this.variant = "default";
    }
    render() {
        return (h(Host, { key: 'e8e29f276130fc11ff75cb5af88073b3ed1ca19d' }, h("slot", { key: 'c244347dfd753d771fdcb50498626c91d2353dc5' })));
    }
    static get is() { return "ux-copy"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["copy.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["copy.css"]
        };
    }
    static get properties() {
        return {
            "strong": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean | undefined",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [{
                            "name": "reflects",
                            "text": undefined
                        }],
                    "text": "Indicates if the text should be strong."
                },
                "attribute": "strong",
                "reflect": true
            },
            "light": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean | undefined",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [{
                            "name": "reflects",
                            "text": undefined
                        }],
                    "text": "Indicates if the text should be light."
                },
                "attribute": "light",
                "reflect": true
            },
            "variant": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "\"title\" | \"tiny\" | \"teaser\" | \"default\"",
                    "resolved": "\"default\" | \"teaser\" | \"tiny\" | \"title\"",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [{
                            "name": "default",
                            "text": "\"default\""
                        }, {
                            "name": "reflects",
                            "text": undefined
                        }],
                    "text": "Specifies the variant of the text."
                },
                "attribute": "variant",
                "reflect": true,
                "defaultValue": "\"default\""
            }
        };
    }
}
//# sourceMappingURL=copy.js.map
